<script>
import TwConfirmDialog from '../../../components/TwConfirmDialog';

export default {
  components: {
    TwConfirmDialog,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    src: {
      type: String,
      required: true,
    },
  },
  computed: {
    changed() {
      return this.title !== this.formTitle;
    },
  },
  methods: {
    remove() {
      this.confirm = false;
      this.toggled = false;
      this.$emit('remove');
    },
    toggle() {
      this.$refs.dialog.open();
    },
    reset() {
      this.formTitle = this.title;
    },
    update() {
      this.toggled = false;
      this.$emit('update', {
        title: this.formTitle,
      });
    },
  },
  data() {
    return {
      toggled: false,
      image: null,
      height: null,
      width: null,
      confirm: false,
      formTitle: null,
    };
  },
  created() {
    this.formTitle = this.title;
    this.image = new Image();
    this.image.src = this.src;
    this.image.addEventListener('load', () => {
      this.height = this.image.height;
      this.width = this.image.width;
    });
  },
};
</script>

<template>
  <v-dialog
    v-model="toggled"
    :max-width="width"
  >
    <template v-slot:activator="{ on }">
      <v-flex class="ski-area-slope-maps-title">
        {{ title }}
      </v-flex>
      <v-img
        v-on="on"
        :src="src"
        :height="height"
        :width="width"
        class="ski-area-slope-maps-toggle-image"
        min-width="100%"
        min-height="100%"
        max-width="200px"
        max-height="200px"
        position="center center"
      />
    </template>
    <template>
      <v-card>
        <v-flex pa-3>
          <v-text-field
            :label="$t('snowGuarantee.labels.title')"
            v-model="formTitle"
            clearable
          />
          <v-img
            :src="src"
            :height="height"
            :width="width"
            max-width="100%"
            contain
          />
        </v-flex>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <div v-if="changed">
            <v-btn
              @click="update"
              color="primary"
              flat
            >
              {{ $t('buttons.update') }}
            </v-btn>
            <v-btn
              @click="reset"
              color="primary"
              flat
            >
              {{ $t('buttons.cancel') }}
            </v-btn>
          </div>
          <div v-if="!changed">
            <v-btn
              @click="toggle"
              color="red"
              flat
            >
              {{ $t('buttons.delete') }}
            </v-btn>
            <v-btn
              @click="toggled = false"
              color="primary"
              flat
            >
              {{ $t('buttons.close') }}
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </template>
    <template>
      <tw-confirm-dialog
        ref="dialog"
        :title="$t('slopeMaps.image.alert')"
        :description="$t('slopeMaps.image.confirm')"
        @confirm="remove"
      />
    </template>
  </v-dialog>
</template>

<style lang="scss">
  .ski-area-slope-maps-title {
    position: absolute;
    font-size: 16px;
    z-index: 10;
    color: white;
    margin: 5px;
    text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.8);
  }

  .ski-area-slope-maps-toggle-image {
    cursor: pointer;
    opacity: 1;
    transition: .2s opacity ease;

    &:hover {
      opacity: .8;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ski/areas/SkiAreaSlopeMapsImage.vue